module.exports = __webpack_public_path__ + "5aab0800aa7ba229a1a7ee22141b80a7.mp4";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/psyker-blast.mp4
// module id = 641
// module chunks = 0